import { Ng2StateDeclaration } from '@uirouter/angular';

import { UserListComponent } from './components/user-list/user-list.component';

export const usersState: Ng2StateDeclaration = {
    // parent: 'app', // declares that 'users' is a child of 'app'
    name: 'user-list',
    url: '/project/:projectId/admin/users',
    component: UserListComponent,
    params: {
        projectId: {squash: true, value: null}
    }
};

export const USERS_STATES = [
    usersState
];
